module.exports = __webpack_public_path__ + "static/img/通知公告@4x.57817675.png";